/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheModalIframe.vue?vue&type=template&id=fcfb339e"
import script from "./TheModalIframe.vue?vue&type=script&lang=js"
export * from "./TheModalIframe.vue?vue&type=script&lang=js"
import style0 from "./TheModalIframe.vue?vue&type=style&index=0&id=fcfb339e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports